import { useLocation } from 'react-router-dom';
import { ErrorPageTmpl } from './templates';

interface ErrorBoundaryProps {
  isUnderSubsystem?: boolean;
}

/**
 * should use within `GlobalContainer`
 */
export function ErrorBoundary(props: ErrorBoundaryProps) {
  const { pathname } = useLocation();

  return (
    <ErrorPageTmpl title="システムエラー" homePath={`/${pathname.split('/')[1]}/main-menu`} {...props}>
      予期せぬエラーが発生しました。
      <br />
      <br />
      システム管理者にご連絡ください。
      <br />
      <br />
    </ErrorPageTmpl>
  );
}
